export default __webpack_public_path__ + "static/media/phone_call.c64b8c4c.svg";